module.exports = __webpack_public_path__ + "static/media/light_delete.090c3176.svg";